import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Stack, Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import apiService from '../utils/apiService';

const ChangePasswordPage = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentPassword || !newPassword) {
      setSnack({ open: true, msg: 'Please fill both fields', severity: 'warning' });
      return;
    }
    setLoading(true);
    try {
      await apiService.post('auth/change-password', { currentPassword, newPassword });
      setSnack({ open: true, msg: 'Password updated successfully', severity: 'success' });
      setCurrentPassword('');
      setNewPassword('');
      setTimeout(() => navigate(-1), 800);
    } catch (e) {
      setSnack({ open: true, msg: e?.message || 'Failed to change password', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper elevation={6} sx={{ width: '100%', maxWidth: 420, p: 3 }}>
        <Typography variant='h5' sx={{ mb: 2, fontWeight: 600 }}>Change Password</Typography>
        <Box component='form' onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label='Current Password'
              type='password'
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              fullWidth
              autoFocus
            />
            <TextField
              label='New Password'
              type='password'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              fullWidth
            />
            <Stack direction='row' spacing={1} justifyContent='flex-end'>
              <Button variant='outlined' onClick={() => navigate(-1)} disabled={loading}>Back</Button>
              <Button type='submit' variant='contained' disabled={loading}>
                {loading ? 'Updating...' : 'Update Password'}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Paper>

      <Snackbar open={snack.open} autoHideDuration={2500} onClose={() => setSnack({ ...snack, open: false })}>
        <Alert onClose={() => setSnack({ ...snack, open: false })} severity={snack.severity} variant='filled' sx={{ width: '100%' }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ChangePasswordPage;
